import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { env } from "utils/env";
import OverflowTitleTooltip from "../common/display/OverflowTitleTooltip";
import Icon from "@mui/material/Icon";
import { ListItemIcon, StyledNavLink, ListItemText } from "./MenuStyle";
const envVariables = env;

const ExternalMenuItem = ({ menu, drawerOpen, activeRoute }) => {
  const { t } = useTranslation();

  /*
    Two types of paths are supported in variable 'menu.path':
        1.) "/external/env/REACT_APP_LSNG": A new tab will be opened with the URL from '.env' file (variable: 'REACT_APP_LSNG').
        2.) "/external/https:/www.google.com": A new tab will be opened with the URL from from here: 'https:/www.google.com'.
    Note: In both cases URLs need to start with 'http'/'https'.
  */

  const isFromEnv = menu.path.toLowerCase().indexOf("/external/env/") !== -1;
  const path = isFromEnv
    ? envVariables[menu.path.substring(14, menu.path.length)]
    : menu.path.substring(10, menu.path.length);

  return (
    <StyledNavLink
      to={path}
      isActive={activeRoute && activeRoute(menu.route)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ListItemIcon>
        <Icon>{menu.icon}</Icon>
      </ListItemIcon>
      <OverflowTitleTooltip title={t(menu.text)}>
        <ListItemText primary={t(menu.text)} disableTypography={true} drawerOpen={drawerOpen} />
      </OverflowTitleTooltip>
    </StyledNavLink>
  );
};

ExternalMenuItem.propTypes = {
  menu: PropTypes.object,
  drawerOpen: PropTypes.bool.isRequired,
  activeRoute: PropTypes.func.isRequired
};

export default ExternalMenuItem;
